import { AI_FORM_CONFIG } from '../constants';

export const filterSensitiveFields = (
  formData: Record<string, unknown>,
): Record<string, unknown> => {
  const filtered: Record<string, unknown> = {};

  Object.entries(formData).forEach(([fieldName, value]) => {
    const isSensitive = AI_FORM_CONFIG.SENSITIVE_FIELD_PATTERNS.some(
      (pattern) => pattern.test(fieldName),
    );

    if (!isSensitive) {
      filtered[fieldName] = value;
    }
  });

  return filtered;
};

export const hasAnalyzableContent = (
  formData: Record<string, unknown>,
): boolean => {
  const filteredFields = filterSensitiveFields(formData);

  return Object.entries(filteredFields).some(([_, value]) => {
    if (typeof value === 'string') {
      return value.trim().length > 0;
    }

    return value !== undefined && value !== null && value !== '';
  });
};
